module.exports = __webpack_public_path__ + "img/consulente.50233f28.jpg";